import { listReport } from './EmployeeByDay/AttendanceEmployee.i18n.en'

export const attendanceEmployee = {
  listReport,
}
